import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'type',
    fieldName: '类型',
    url: 'PaymentCycleType',
    selectType: 1
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'day',
    fieldName: '票到天数'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }
]
